<template>
  <div>
    <div class="quick-view" style="height:92vh">
      <!-- <div class="text-sm-left font-weight-bold px-5">
        Thông tin học viên
      </div> -->
      <v-divider style="margin: 2px 0px 45px 16px"></v-divider>
      <v-card-text v-if="!isLoadingData" class="px-9 pt-0">
        <v-row>
          <v-col cols="12" md="3" style="text-align: left; margin-top: -23px">
            <v-row v-if="contactData" style="margin-top: -15px">
              <v-col cols="12" md="12" class="pa-0">
                <v-row>
                  <v-col cols="4" id="avt">
                    <img class="student-avatar" src="/img/avt.png" alt="" />
                  </v-col>
                  <v-col cols="8">
                    <div class="d-flex align-center mt-7">
                      <div class="student-name" v-if="contactChildName">
                        {{ contactChildName }}
                      </div>
                    </div>
                    <div class="student-code">
                      <div>
                        Code:
                        <span v-if="_.get(this.contactData, 'code', '')">{{
                          _.get(this.contactData, "code", "")
                        }}</span>
                      </div>
                      <div>
                        Mã học sinh:
                        <span v-if="studentId"
                          >{{ studentId }}
                          <v-tooltip right>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                size="small"
                                rounder
                                icon
                                v-on="on"
                                @click="handleCopy(studentId)"
                              >
                                <v-icon>mdi-content-copy</v-icon>
                              </v-btn>
                            </template>
                            <span>Copy</span>
                          </v-tooltip>
                        </span>
                      </div>
                    </div>
                    <div id="advanded" class="d-flex student-code">
                      <div class="mt-1 mr-2">Điểm danh:</div>
                      <div>
                        <div class="d-flex align-center">
                          <v-checkbox
                            style="margin-top: 0px"
                            v-model="priority"
                            hide-details
                            label="Ưu tiên"
                            @click="checkPriority()"
                          >
                          </v-checkbox>
                        </div>
                        <div class="d-flex align-center">
                          <v-checkbox
                            style="margin-top: 0px"
                            v-model="no_call"
                            hide-details
                            label="Không ưu tiên"
                            @click="checkNoCall()"
                          >
                          </v-checkbox>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex student-code mt-2">
                      <div class="mt-1 mr-2">GV Cover:</div>
                      <div>
                        <v-checkbox
                          style="margin-top: 0px"
                          v-model="coverTeacher"
                          hide-details
                          label="Không đồng ý"
                          @click="changeRequest('tutor')"
                        >
                        </v-checkbox>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <div class="w-100 mt-2">
                <div class="d-flex align-center justify-space-around">
                  <template v-for="(item, index) in actions">
                    <div
                      v-if="
                        item.permission
                          ? checkAuthorization(item.permission)
                          : true
                      "
                      :key="item.key"
                    >
                      <v-menu
                        offset-y
                        v-if="
                          item.key === 'call' &&
                          contactData &&
                          contactData.phoneRelated &&
                          contactData.phoneRelated.length
                        "
                      >
                        <template v-slot:activator="{ on: menu, attrs }">
                          <div
                            class="d-flex flex-column align-center"
                            v-bind="attrs"
                            v-on="menu"
                          >
                            <img :src="item.img" alt="" />
                            <p
                              :class="index === 0 ? 'pt-2 mt-1' : 'mt-1'"
                              style="font-size: 11px"
                            >
                              {{ item.text }}
                            </p>
                          </div>
                        </template>
                        <v-list>
                          <v-list-item
                            @click="
                              clickExecuteCall(contactData, contactMobile)
                            "
                            class="main-mobile"
                          >
                            <v-list-item-title>{{
                              formatNormalStylePhone(contactMobile)
                            }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            v-for="(phone, index) in contactData.phoneRelated"
                            :key="index"
                            @click="clickExecuteCall(contactData, phone)"
                            class="sub-mobile"
                          >
                            <v-list-item-title>{{
                              formatNormalStylePhone(phone)
                            }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <div
                        v-else
                        @click="item.disable ? '' : actionUser(item.key)"
                        style="cursor: pointer"
                      >
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              class="d-flex flex-column align-center"
                              v-bind="attrs"
                              v-on="item.disable ? on : ''"
                            >
                              <img :src="item.img" alt="" />
                              <p
                                :class="index === 0 ? 'pt-2 mt-1' : 'mt-1'"
                                style="font-size: 11px"
                              >
                                {{ item.text }}
                              </p>
                            </div>
                          </template>
                          <span>Tính năng chưa phát triển</span>
                        </v-tooltip>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div class="d-flex align-center mb-2 w-full">
                <v-icon color="black" small class="mr-2"
                  >mdi-heart-outline</v-icon
                >
                <div style="font-size: 12px">
                  Ngày sinh:
                  <span v-if="contactBirthday">{{ contactBirthday }}</span>
                </div>
              </div>
              <div class="d-flex align-center mb-2 w-full">
                <v-icon color="black" small class="mr-2"
                  >mdi-account-supervisor-outline</v-icon
                >
                <div class="d-flex" style="font-size: 12px">
                  <span
                    class="m-auto pr-2"
                    :style="{
                      width:
                        contactChilds && contactChilds.length ? '60%' : '100%',
                    }"
                    >Phụ huynh:
                    <span v-if="contactParentName">{{
                      handleShowParentName(contactParentName)
                    }}</span></span
                  >
                  <v-select
                    v-if="contactChilds && contactChilds.length"
                    ref="child-select"
                    class="mt-0 w-1-2 custome-child-other"
                    @change="changeContactChild"
                    :items="contactChilds"
                    :label="`${contactChilds.length} con khác`"
                    item-text="fullName"
                    item-value="vhUserId"
                    flat
                    hide-details
                    dense
                    no-data-text="Không có dữ liệu"
                    :menu-props="{ bottom: true, offsetY: true }"
                    v-model="selectedContactChild"
                  >
                  </v-select>
                </div>
              </div>
              <div class="d-flex align-center mb-2 w-full">
                <v-icon color="black" small class="mr-2"
                >mdi-phone</v-icon
                >
                <div class="d-flex align-center" style="font-size: 12px">
                  <span>SĐT:
                    <span>{{formatNormalStylePhone(contactMobile)}}</span>
                  </span>
                  <v-btn icon small class="ml-2" @click="handleCopy(contactMobile)">
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </div>
              </div>

              <div class="d-flex align-center mb-2 w-full">
                <v-icon color="black" small class="mr-2"
                  >mdi-home-outline</v-icon
                >
                <div style="font-size: 12px">
                  Đ/c: <span>{{ contactAddress }}</span>
                </div>
              </div>
              <div class="d-flex align-center mb-2 w-full">
                <v-icon color="black" small class="mr-2">mdi-town-hall</v-icon>
                <div style="font-size: 12px">
                  Trường: <span>{{ school && school.school_name }}</span>
                </div>
              </div>
              <v-divider class="mr-2"></v-divider>
              <v-col cols="12" md="12" class="pa-0 mt-3 pr-3">
                <div v-if="programsOfContact && programsOfContact.length" class="pa-0 mb-3 pb-2 pl-1 d-flex" style="width: 100%; overflow: auto" id="style-2">
                  <span v-for="(i, key) in programsOfContact" :key="key">
                    <v-btn
                      active-class="active"
                      :class="key == chosenSubject ? 'active' : ''"
                      class="customer-learning"
                      @click="changeSubject(i, key)"
                    >
                      <span
                        v-if="i.curriculum_id && i.curriculum_id !== 0"
                        >{{ getSubjectById(i.subject_id).name }}
                        <span v-if="mapProgramIdAndProgram[i.curriculum_id]">{{
                          mapProgramIdAndProgram[i.curriculum_id].code
                        }}</span></span
                      >
                      <span v-else>IELTS TỰ HỌC</span>
                    </v-btn>
                  </span>
                </div>
                <div v-if="countSubjects">
                  <b class="title-student-class">
                    học bạ {{ getSubjectById(subjectId).name }}
                    <span
                      style="font-size: 14px !important"
                      v-if="mapProgramIdAndProgram[programId]"
                      >{{ mapProgramIdAndProgram[programId].code }}</span
                    >
                  </b>
                  <div class="mt-2 mb-2 pa-3 class-list">
                    <div v-if="checkPermissionByRoute()">
                      <div style="font-size:12px;line-height:8px;font-weight:500;color:rgba(0, 0, 0, 0.6);font-family: 'Roboto', sans-serif;">Quản lý lớp</div>
                      <div style="font-size:14px;font-weight:600;line-height:16px;" class="pt-2">{{contact && contact.homeroom_teacher_name ? contact.homeroom_teacher_name : "" }}</div>
                    </div>
                    <v-combobox
                      v-else
                      v-model="dataHomeroomTeacher"
                      :items="listGVCNQuickView"
                      item-text="name"
                      :item-value="(item) => item"
                      label="Quản lý lớp"
                      class="fill-text-field"
                      @change="handleChangeHeadTeacher"
                      @click:clear="handleRemoveHeadTeacher"
                      clearable
                      hide-details
                      no-data-text="Không có dữ liệu"
                    />
                  </div>
                  <br />
                  <b v-if="subjectId" class="title-student-class">
                    lớp {{ getSubjectById(subjectId).name }}
                    <span
                      style="font-size: 14px !important"
                      v-if="mapProgramIdAndProgram[programId]"
                      >{{ mapProgramIdAndProgram[programId].code }}</span
                    >
                    đang học
                  </b>
                  <div v-if="loadingClass">
                    <div class="loader"></div>
                  </div>
                  <div v-if="!loadingClass">
                    <div v-if="!studentClassList || studentClassList.length == 0">
                    Không có lớp nào
                    </div>
                    <div
                      class="mt-2 mb-2 pa-3 class-list"
                      id="style-2"
                      v-if="studentClassList.length && selectedSubjectId"
                    >
                      <div
                        class="class-item mb-2"
                        v-for="(item, key) in studentClassList"
                        :key="key"
                      >
                        <div class="class-studying">
                          <div>
                            <span class="d-webkit-box">
                              <v-icon style="margin-right: 5px"
                                >mdi-book-open-blank-variant</v-icon
                              >
                              <b style="font-weight: 700">{{ item.name }}</b>
                            </span>
                            <span>
                              <v-icon style="margin-right: 5px"
                                >mdi-account</v-icon
                              >
                              <span>
                                <span
                                  :style="
                                    'font-weight:600;color:' + item.status_color
                                  "
                                >
                                  {{ item.status_name }}
                                </span>
                                <span v-if="item.status_name === 'Lớp nháp'">
                                  <v-badge color="white">
                                    <template #badge>
                                      <v-tooltip
                                        top
                                        color="white"
                                        content-class="join-date-tooltip"
                                      >
                                        <template
                                          v-slot:activator="{ on, attrs }"
                                        >
                                          <v-icon
                                            style="margin-left: 6px"
                                            v-bind="attrs"
                                            v-on="on"
                                            size="18"
                                            color="black"
                                            >mdi-information-outline
                                          </v-icon>
                                        </template>
                                        <div>
                                          <div style="font-size: 12px">
                                            Lớp khai giảng :
                                            {{
                                              formatDateSlash(
                                                item.class_start_time
                                              )
                                            }}
                                          </div>
                                        </div>
                                      </v-tooltip>
                                    </template>
                                    {{ " | Ngày vào lớp: " }}
                                    <span style="margin-left: 6px">-</span>
                                  </v-badge>
                                </span>
                                <span v-if="isReserve(item)">
                                  {{
                                    `Ngày đi học lại: ${item.learn_again_time}`
                                  }}
                                </span>
                                <span
                                  v-if="item.join_date && item.join_date !== ''"
                                >
                                  <v-badge color="white">
                                    <template #badge>
                                      <v-tooltip
                                        top
                                        color="white"
                                        content-class="join-date-tooltip"
                                      >
                                        <template
                                          v-slot:activator="{ on, attrs }"
                                        >
                                          <v-icon
                                            v-bind="attrs"
                                            v-on="on"
                                            size="18"
                                            color="black"
                                            >mdi-information-outline
                                          </v-icon>
                                        </template>
                                        <div>
                                          <div style="font-size: 12px">
                                            Lớp khai giảng :
                                            {{
                                              formatDateSlash(
                                                item.class_start_time
                                              )
                                            }}
                                          </div>
                                          <div
                                            style="
                                              color: blue;
                                              font-size: 12px;
                                              font-weight: bold;
                                            "
                                          >
                                            -
                                            <span
                                              v-if="
                                                isSameDate(
                                                  item.class_start_time,
                                                  item.join_date
                                                )
                                              "
                                              >Học từ đầu chương trình</span
                                            >
                                            <span v-else
                                              >Học từ giữa chương trình</span
                                            >
                                          </div>
                                        </div>
                                      </v-tooltip>
                                    </template>
                                    {{
                                      ` | Ngày vào lớp: ${formatDateSlash(
                                        item.join_date
                                      )}`
                                    }}
                                  </v-badge>
                                </span>
                              </span> </span
                            ><br />
                            <span v-if="item.teacher_full_name">
                              <v-icon style="margin-right: 5px"
                                >mdi-account</v-icon
                              >
                              <span>GV dạy: {{ item.teacher_full_name }}</span
                              ><br />
                            </span>
                            <div
                              v-if="
                                item.class_schedule && item.class_schedule.length
                              "
                              style="display: flex"
                            >
                              <div>
                                <v-icon style="margin-right: 5px"
                                  >mdi-calendar-check</v-icon
                                >
                              </div>
                              <div>
                                <div
                                  v-for="(i, k) in item.class_schedule"
                                  :key="k"
                                  style="line-height: 1.5em"
                                >
                                  <div v-if="i.schedule && i.schedule.length">
                                    <span
                                      v-for="(schedule, key_s) in i.schedule"
                                      :key="key_s"
                                      style="margin-right: 5px"
                                    >
                                      {{ schedule.time }}
                                      <b class="schedule-day"
                                        >({{ schedule.day }})</b
                                      >
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <span class="d-webkit-box">
                              <v-icon style="margin-right: 5px"
                                >mdi-content-save</v-icon
                              >
                              <b>
                                Đã học:
                                {{
                                  item.number_lessons_passed
                                    ? item.number_lessons_passed
                                    : 0
                                }}/{{
                                  item.number_lessons ? item.number_lessons : 0
                                }}
                                (buổi)
                              </b>
                            </span>
                          </div>
                          <div class="more">
                            <v-menu
                              offset-y
                              transition="slide-x-transition"
                              bottom
                              left
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  color="primary"
                                  dark
                                  v-bind="attrs"
                                  v-on="on"
                                  icon
                                >
                                  <v-icon>mdi-dots-horizontal</v-icon>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item @click="goToClassScheduling(item)">
                                  <v-list-item-title>
                                    <v-icon>mdi-information</v-icon> Thông tin chi
                                    tiết học viên
                                  </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                  v-if="checkConditionShowTicket(item)"
                                  @click="showPopupOnLeave(item)"
                                >
                                  <v-list-item-title>
                                    <v-icon>mdi-calendar</v-icon> Nghỉ phép
                                  </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                  v-if="checkConditionShowTicket2(item)"
                                  @click="showPopupReserve(item)"
                                >
                                  <v-list-item-title>
                                    <v-icon>mdi-account-box</v-icon> Bảo lưu
                                  </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                  v-if="isReserve(item)"
                                  @click="showPopupLearnAgain(item)"
                                >
                                  <v-list-item-title>
                                    <v-icon>mdi-account-box</v-icon> Đi học lại
                                  </v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="['huyenntk', 'huynq', 'dungbp', 'uyenptm', 'thubtt', 'tranglt_tester', 'tuanpg', 'maymth', 'phuonght2'].includes(getUser)" @click="showPopupTransferFee(item)">
                                  <v-list-item-title>
                                    <v-icon>mdi-autorenew</v-icon> Chuyển phí
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="mt-2 mb-2 pa-3 class-list"
                      id="style-2"
                      v-if="studentClassList.length && !selectedSubjectId"
                    >
                      <div
                        class="class-item mb-2"
                        v-for="(item, key) in studentClassList"
                        :key="key"
                      >
                        <div>
                          <div class="d-flex my-2"><img src="../assets/book.svg" alt=""><span class="mx-2"><strong>{{item.courseName}}</strong></span></div>
                          <div>
                            <span><img src="../assets/user.svg" alt=""></span>
                            <span class="mx-2">
                              <span v-if="!item.isExpired">
                                <span v-if="item.isActive === 1">
                                  <strong style="color: #04D300">Đã kích hoạt</strong>
                                  <span class="mx-2">Ngày vào học: {{item.firstJoinDate ? formatDateSlash(item.firstJoinDate) : '--'}}</span>
                                </span>
                                <span v-if="item.isActive === 2">
                                  <strong v-if="!checkExpiredate(item.expiredate)" style="color: #FF8A00">Chưa kích hoạt</strong>
                                  <strong v-if="checkExpiredate(item.expiredate)" style="color: #6D6D6D">Hết hạn kích hoạt</strong>
                                  <span class="mx-2">Kích hoạt trước ngày : {{item.expiredate ? formatDateSlash(item.expiredate) : '--'}}</span>
                                </span>

                              </span>
                              <span v-else>
                                <strong style="color: #6D6D6D">Hết hạn</strong>
                                <span class="mx-2">Ngày vào học: {{item.firstJoinDate ? formatDateSlash(item.firstJoinDate) : '--'}}</span>
                              </span>
                            </span>
                          </div>
                          <div class="d-flex my-2"><img src="../assets/enter.svg" alt=""><span class="mx-2">Lần vào học gần nhất: {{item.lastJoinDate ? formatDateSlash(item.lastJoinDate) : "--"}} {{formatHour(item.lastJoinDate)}}</span></div>
                          <div class="d-flex align-start my-2">
                            <img src="../assets/book-2.svg" alt="">
                            <div class="mx-2" v-if="IELTS_CONVERSATION_NAME.includes(item.courseFolderCode)">
                              <div>
                                <span>Mục tiêu hoàn thành:</span>
                              </div>
                              <div class="ml-2">
                                <span>- {{item.cupRatio}} cup</span>
                                <br>
                                <span>- {{item.lessonRatio}} chủ đề</span>
                              </div>
                            </div>
                            <template v-else-if="IELTS_PRONUNCIATION_NAME.includes(item.courseFolderCode)">
                              <span class="mx-2">
                              Bài đã học:
                              <span v-if="item.numbOfDoneInstance && item.numbOfInstance">{{item.numbOfDoneInstance}}/{{item.numbOfInstance}}
                              </span><span v-else>--</span></span>
                            </template>
                            <template v-else>
                              <span class="mx-2">
                              Bài đã hoàn thành:
                              <span v-if="item.numbOfDoneInstance && item.numbOfInstance">{{item.numbOfDoneInstance}}/{{item.numbOfInstance}}
                              </span><span v-else>--</span></span>
                            </template>
                          </div>
                          <div class="d-flex my-2 align-center">
                            <v-icon style="font-size: 16px">mdi-calendar-clock</v-icon>
                            <span class="mx-2">Ngày hết hạn: {{item.endDate ? formatDateSlash(item.endDate) : '--'}}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-divider vertical></v-divider>
          <v-col cols="12" md="9" class="pt-4 pl-8 pr-0 pb-2">
            <validation-observer v-slot="{ handleSubmit }">
              <v-row style="margin-top: -30px">
                <v-col cols="12" md="12" style="text-align: right" v-if="false">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Thông tin ghi chú"
                    :rules="{ required: reloadCreateNote, max: 255 }"
                  >
                    <v-textarea
                      label="Nhập ghi chú"
                      rows="3"
                      v-model="note"
                      :error-messages="errors"
                      @keydown.enter.exact.prevent="
                        handleSubmit(clickCreateHistoryContact)
                      "
                    />
                  </validation-provider>
                  <v-btn
                    class="d-flex"
                    small
                    @click.prevent="handleSubmit(clickCreateHistoryContact)"
                    color="primary"
                    style="float: left"
                    >Tạo</v-btn
                  >
                  <v-btn
                    v-show="isSupport"
                    small
                    @click="returnToBackStatus()"
                    color="primary"
                    style="float: right"
                    >Đã hỗ trợ CSKH</v-btn
                  >
                </v-col>
                <SpecialCareDetail v-if="isShowSpecialCareDetailTable" :item="contact" style="margin-bottom: 40px" @show-detail="handleShowSpecialCareDetail"></SpecialCareDetail>
                <v-tabs v-model="tab" grow>
                  <v-tabs-slider></v-tabs-slider>
                  <template v-for="(item, key) in tabs">
                    <v-tab
                      v-show="
                        (item === 'Công việc' &&
                          contact &&
                          (contact.type_curriculum == TYPE_CURRICULUM_OBJ.ONLINE || contact.type_curriculum == TYPE_CURRICULUM_OBJ.IELTS_COURSE) &&
                          contact.type_customer_care !== 3) ||
                        item !== 'Công việc'
                      "
                      :key="'tab' + key"
                      :style="
                        item == 'Vận hành' &&
                        (filterForm.typeId == 1 || filterForm.typeId == 3)
                          ? { display: 'none' }
                          : ''
                      "
                    >
                      {{ item }}
                    </v-tab>
                  </template>
                  <template
                    v-for="(item, key) in tabs.slice(0, tabs.length - 3)"
                  >
                    <v-tab-item
                      v-show="
                        (item === 'Công việc' &&
                          contact &&
                          (contact.type_curriculum == TYPE_CURRICULUM_OBJ.ONLINE || contact.type_curriculum == TYPE_CURRICULUM_OBJ.IELTS_COURSE) &&
                          contact.type_customer_care !== 3) ||
                        item !== 'Công việc'
                      "
                      :key="'chil' + key"
                    >
                      <v-col
                        cols="12"
                        md="12"
                        class="pa-0 mt-4"
                      >
                        <BlendedTutorTaskTab
                          :taskType="taskType"
                          v-if="key === 3"
                          type-screen="tutor"
                          :curriculumId="
                            programsOfContact[chosenSubject].curriculum_id
                          "
                          :lms-core-user-id="contact.lms_core_user_id"
                        ></BlendedTutorTaskTab>
                        <contact-history-table
                          v-if="(key === tab || key === 0) && tab !== 3"
                          :style="
                            tab == 2 &&
                            (filterForm.typeId == 1 || filterForm.typeId == 3)
                              ? { visibility: 'hidden' }
                              : ''
                          "
                          :contactHistories="contactHistories"
                          :orderList="orderList"
                          :totalListOrder="totalListOrder"
                          :showSTT="false"
                          @deleteContactHistory="deleteContactNoteHistory"
                          :currentUserId="currentUserId"
                          @updateContactHistory="updateContactNoteHistory"
                          :tab="parseInt(tab)"
                          :contactId="contactId"
                          :contactNoteHistories="contactNoteHistories"
                          :routineStudentId="routineStudentId"
                          :selectedStudent="contact"
                          :filterForm="filterForm"
                          :lmsCoreUserID="selectedContactChild"
                          :listVideos="listVideos"
                          :attendedStudent="attendedStudent"
                          :selectedProgram="selectedProgram"
                          :lessonByStudent="lessonByStudent"
                          :selectedSubjectId="selectedSubjectId"
                          :classSelect="classSelect"
                          @getListVideos="getListVideos"
                          :totalListVideo="totalListVideo"
                          :curriculumId="curriculumId"
                          @set-arrange-class-type="setArrangeClassType"
                          @open-sort-class-popup="handleShowSortClassPopup"
                        />
                      </v-col>
                    </v-tab-item>
                  </template>
                  <v-tab-item>
                    <ListTicket :contact="contact"></ListTicket>
                  </v-tab-item>
                  <v-tab-item>
                    <NoteTab ref="noteTab" :id="studentId"></NoteTab>
                  </v-tab-item>
                  <v-tab-item>
                    <ActivityTab ref="activityTab" :id="studentId"></ActivityTab>
                  </v-tab-item>
                </v-tabs>
                <v-col v-if="totalItem > 300" cols="12" md="12" class="pt-0">
                  <v-btn color="success" @click="clickViewHistoryContact"
                    >Xem thêm</v-btn
                  >
                </v-col>
              </v-row>
            </validation-observer>
          </v-col>
        </v-row>
      </v-card-text>
      <v-skeleton-loader
        v-else
        min-width="300"
        style="margin-top: -42px"
        type="article"
      ></v-skeleton-loader>
    </div>
    <modal-count-interaction
      v-if="isActiveCountInteractions"
      @closePopUp="closePopupInteractions"
      :isActiveCountInteractions="isActiveCountInteractions"
      :dataInteraction="dataInteraction"
      :totalItemActionLogs.sync="totalItemActionLogs"
      :currentPage.sync="currentPage"
    />
    <modal-active-codes
      v-if="isActiveCodes"
      :isActiveCodes="isActiveCodes"
      :activeCodesCustomer="activeCodesCustomer"
      :dataContact="dataContact"
    />
    <v-dialog v-model="isPopupOnLeave" width="544" persistent>
      <popup-on-leave
        :detailStudent="detailStudent"
        :isPopupOnLeave="isPopupOnLeave"
      />
    </v-dialog>
    <v-dialog v-model="isPopupReserve" width="544" persistent>
      <popup-reserve
        :detailStudent="detailStudent"
        :isPopupReserve="isPopupReserve"
      />
    </v-dialog>
    <v-dialog
      v-if="isPopupLearnAgain"
      v-model="isPopupLearnAgain"
      width="544"
      persistent
    >
      <popup-learn-again
        :detailStudent="detailStudent"
        :isPopupLearnAgain="isPopupLearnAgain"
        @closePopupLearnAgain="closePopupLearnAgain"
        @createLearnAgainSuccessfully="createLearnAgainSuccessfully"
      />
    </v-dialog>
    <v-dialog v-model="modalDetailClass" :width="this.$vuetify.breakpoint.width < 1366 ? 1100 : 1200">
      <ModalDetailClass :studentCareInfo="contact" :studentProductId="contact.student_product_id" :closeModalDetailClass="closeModalDetailClass"></ModalDetailClass>
    </v-dialog>
    <v-dialog v-if="isPopupTransferFee" v-model="isPopupTransferFee" width="85vw" persistent>
      <transfer-fee
        :student="detailStudent"
        :isPopupTransferFee="isPopupTransferFee"
        @closePopup="isPopupTransferFee = false"
      />
    </v-dialog>
    <Arrange1NClassPopup v-if="isShowArrangeClassPopup" :studentId="studentId" :studentCareInfo="contact" :isShow="isShowArrangeClassPopup" @close="closeArrange1NPopup"></Arrange1NClassPopup>
  </div>
</template>
<script>
/* eslint-disable */
import Arrange1NClassPopup from "@/components/arrange_class/Arrange1NClassPopup";
import mapSubject from "@/mixins/mapSubject";
import SpecialCareDetail from "@/modules/student_care/components/SpecialCareDetail";
import BlendedTutorTaskTab from "@/modules/student_detail_bt/components/BlendedTutorTaskTab";
import { mapActions, mapGetters, mapState } from "vuex";
import * as moment from "moment";
import {
  TYPE_CALL_STATUS,
  CHECK_ATTENDANCE_PRIORITY,
  ORDER_DEPOSIT_TYPE,
  ORDER_FINISH_TYPE,
  namesOrderContactStatusTc, SCHOOL_LEVEL, TYPE_CURRICULUM_OBJ,
} from "@/helpers/constant";
import ModalDetailClass from "@/modules/student_care/components/ModalDetailClass";
import TokenService from "../../../helpers/token";
import ContactHistoryTable from "./ContactHistoryTable.vue";
import ModalCountInteraction from "./ModalCountIeraction.vue";
import ModalActiveCodes from "./ModalActiveCodes.vue";
import PopupOnLeave from "./PopupOnLeave.vue";
import PopupReserve from "./PopupReserve.vue";
import PopupLearnAgain from "./PopupLearnAgain.vue";
import ListTicket from './ListTicket.vue';
import NoteTab from "@/modules/student_care/components/NoteTab";
import ActivityTab from "@/modules/student_care/components/ActivityTab";
import { TOAN } from "../store/mutation-types";
import ContactRepository from "../../../services/ContactRepository";
import TicketRespository from "@/services/TicketRespository";
import BlendedCareServices from '@/services/BlendedCareRepository';
import { contactCreator } from '@/helpers/constant';
import TaskRepository from "@/services/TaskRepository";
import {POPUP_DETAIL_TAB_INDEX} from "@/modules/student_care/constant/constant";
import TransferFee from "../../transfer-fee/index.vue";
import teacherCoverRequest from "@/mixins/teacherCoverRequest";

export default {
  components: {
    Arrange1NClassPopup,
    TransferFee,
    ModalDetailClass,
    SpecialCareDetail,
    NoteTab,
    ActivityTab,
    BlendedTutorTaskTab,
    ContactHistoryTable,
    ModalCountInteraction,
    ModalActiveCodes,
    PopupOnLeave,
    PopupReserve,
    PopupLearnAgain,
    ListTicket,
  },
  name: "ContactStatusFilterForm",
  mixins: [mapSubject, teacherCoverRequest],
  props: {
    id: {
      type: Number,
      default: 0,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    contactId: {
      type: Number,
      default: 0,
    },
    users: {
      type: Array,
      default: () => [],
    },
    routineStudentId: {
      type: Number,
      default: 0,
    },
    homeroomTeacher: {
      type: Object,
      default: () => {},
    },
    contact: {
      type: Object,
      default: () => {},
    },
    taskType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      arrangeClassType: 0,
      isShowArrangeClassPopup: false,
      listTransferOrderV2: [],
      isPopupTransferFee: false,
      IELTS_CONVERSATION_NAME: ['IELTS_CONVERSATION'],
      IELTS_PRONUNCIATION_NAME: ['IELTS_PRONUNCIATION'],
      TYPE_CURRICULUM_OBJ,
      modalDetailClass: false,
      studentSpecialCareDetail: {},
      curriculumId: [],
      totalListVideo:null,
      isPopupOnLeave: false,
      isPopupReserve: false,
      contactData: {},
      isLoadingData: false,
      contactAddress: '',
      contactChildName: '',
      contactParentName: '',
      contactMobile: '',
      contactBirthday: '',
      isStatusChange: false,
      statusId: 0,
      note: '',
      totalItem: 0,
      contactHistories: [],
      orderList: [],
      reloadCreateNote: true,
      userId: 0,
      showNote: true,
      currentUserId: '',
      tabs: ['Chăm sóc', 'Lịch sử học tập', 'Đơn hàng' , 'Công việc', 'Trao đổi', 'Logs', 'Ticket',  'Note', 'Hoạt động'],
      tab: 0,
      isSupport: false,
      isActiveCountInteractions: false,
      dataInteraction: {
        listActions: [],
        cycle_point: 0,
        cumulative_point: 0,
      },
      contactStatusList: [],
      activeCodesCustomer: [],
      isActiveCodes: false,
      actionLogTypeList: [],
      mapNamePointActionLog: {},
      totalItemActionLogs: null,
      currentPage: 1,
      dataTime: {},
      contactNoteHistories: [],
      listTransferOrder: [],
      totalListOrder: [],
      subjects: [
        { id: 1, name: "Toán", isDisplay: false },
        // { id: 2, name: 'Vật lý' },
        // { id: 3, name: 'Hóa học' },
        { id: 5, name: "Tiếng anh", isDisplay: false },
        { id: 15, name: "Ngữ văn", isDisplay: false },
      ],
      chosenSubject: 0,
      chosenSubjectName: "Toán",
      objChosenSubject: {},
      contactChilds: [],
      selectedContactChild: this.contact.lms_core_user_id,
      childSelected: this.contact.lms_core_user_id,
      dataHomeroomTeacher: this.homeroomTeacher,
      subjectId: "",
      selectedSubjectId: TOAN,
      detailStudent: {},
      listVideos: [],
      attendedStudent: {},
      dataZalo: {},
      CHECK_ATTENDANCE_PRIORITY,
      priority: false,
      no_call: false,
      isPopupLearnAgain: false,
      dataLevel: null,
      studentClassList: [],
      isCreatedLifeCycleDone: false,
      programsOfContact: [],
      programId: 0,
      selectedProgram: {},
      lessonByStudent: [],
      school: null,
      classSelect: null,
      studentId: '',
      filterForm: {
        openRowMenu: false,
        status: "",
        searchInfo: "",
        courseEndDate: [],
        extend_at: [],
        subjectId: null,
        phoneNumber: "",
        page: 1,
        limit: 20,
        callTypes: [],
        callStatuses: [],
        headTeacher: [],
        subject_ids: [],
        openQuickView: true,
        typeCustomerCare: 1,
        historyCallId: 0,
        historyCallStatusId: [],
        checkboxAll: false,
        pendingPage: 1,
        sales: [],
        compareTypeNumberOfLessons: "eq",
        numberOfLessons: null,
        noEndDate: false,
        hasNoTeacher: false,
        hasNoSale: false,
        class_start_time: [],
        previous_end_date: [],
        class_code: "",
        program_ids: [],
        type_curriculum: "online",
      },
      priority_status: null,
      flagOldDataTeacher: this.homeroomTeacher,
      contactCreator,
      actions: [
        { key: 'call', text: 'Gọi điện', img: '/img/call.png' },
        {
          key: 'zalo', text: 'Gọi Zalo', img: '/img/zalo.png', disable: true,
        },
        { key: 'order', text: 'Tạo đơn hàng', img: '/img/checklist.png', },
        {
          key: 'ticket', text: 'Tạo ticket', img: '/img/pass.png', permission: 'care-submit-ticket_read',
        },
        // {
        //   key: 'planner', text: 'Tạo event', img: '/img/planner.png', disable: true,
        // },
      ],
      loadingClass: false,
    };
  },
  async created() {
    this.isLoadingData = true;
    await this.getListGVCNV2();
    await this.getListProgram();
    await this.getTeacherCoverInfo();
    this.filterForm.typeCustomerCare = this.contact.type_customer_care;
    this.filterForm.tutorSchoolLevel = this.$route.query.tutorSchoolLevel ? this.$route.query.tutorSchoolLevel : SCHOOL_LEVEL.PRIMARY;
    let programOfContactUnique = [];
    this.programsOfContact = await this.getListProgramOfStudentByLmsCoreUserId(
      {
        lmsCoreUserId: this.contact.lms_core_user_id,
        tutorSchoolLevel: this.$route.query.tutorSchoolLevel
      }
    );
    if (this.programsOfContact?.length > 1) {
      this.programsOfContact.forEach((e) => {
        if (
          !programOfContactUnique.some(
            (el) => el.curriculum_id === e.curriculum_id
          )
        ) {
          programOfContactUnique.push(e);
        }
      });
      this.programsOfContact = _.cloneDeep(programOfContactUnique);
      this.programsOfContact.forEach((value, index) => {
        if (value.curriculum_id === this.contact.curriculum_id) {
          this.chosenSubject = index;
        }
      });
    }
    if (this.contact && (this.contact.type_curriculum == TYPE_CURRICULUM_OBJ.ONLINE || this.contact.type_curriculum === TYPE_CURRICULUM_OBJ.IELTS_COURSE) && this.contact.type_customer_care !== 3 && (this.checkAuthorization('create-task-tutor_create') || this.checkAuthorization('create-task-tutor-secondary_create'))) {
      this.actions.push({ key: 'todos', text: 'Tạo công việc', img: '/img/createtask.svg' });
    }
    if (this.programsOfContact && this.programsOfContact.length) {
      await this.getClassListOfSubject(
      this.programsOfContact[this.chosenSubject],
      this.chosenSubject
    );
    }
    await this.fetchContactDataCreated();
    this.isLoadingData = false;
    this.currentUserId = TokenService.getId();
    if (
      this.filterForm.typeCustomerCare === TYPE_CALL_STATUS.GIA_HAN ||
      this.filterForm.typeCustomerCare === TYPE_CALL_STATUS.CHUYEN_SALES
    ) {
      this.tabs[0] = "Gia hạn";
    } else {
      this.tabs[0] = "Chăm sóc";
    }
    this.getPriorityTeacher();
    this.getLessonByStudentAndProgram();
    this.getStudentProductByLmsId();
    setTimeout(() => {
      Bus.$emit("load-right-data", {
        subjectId: this.subjectId,
        programId: this.programId,
      });
    }, 200);
    Bus.$on("closePopupReserve", () => {
      this.isPopupReserve = false;
    });
    Bus.$on("closePopupOnLeave", () => {
      this.isPopupOnLeave = false;
    });
    this.isCreatedLifeCycleDone = true;
    if (this.studentClassList.length) {
      // eslint-disable-next-line prefer-destructuring
      this.classSelect = this.studentClassList[0];
    }
    if(this.contact && this.contact.lms_core_user_id) {
      this.getStudentId(this.contact.lms_core_user_id)
    }
    if (this.$route.query.logFilter) {
      this.tab = POPUP_DETAIL_TAB_INDEX.LOGS;
    }
  },
  computed: {
    getUser() {
      const username = TokenService.getUserName();
      return username ? username.toLowerCase() : username;
    },
    ...mapState("student_care", ["listGVCN", 'listGVCNV2']),
    ...mapGetters("student_care", ["mapProgramIdAndProgram"]),
    isShowSpecialCareDetailTable() {
      return !( _.get(this.contact, 'cancel_lesson', null) === null
        && _.get(this.contact, 'no_adtention', null) === null
        && _.get(this.contact, 'late', null) === null
        && _.get(this.contact, 'no_homework', null) === null
        && _.get(this.contact, 'test', []).length === 0
        && _.get(this.contact, 'change_teacher.data', []).length === 0
        && _.get(this.contact, 'date_next_test', null) === null);
    },
    listGVCNQuickView() {
      return this.listGVCNV2 ? this.listGVCNV2.map((e) => {
        return {
          id: e.id,
          name: e.name,
        }
      }) : []
    },
    getSelectUser() {
      return this.users;
    },
    countSubjects() {
      const noSubject = this.programsOfContact?.length;
      return noSubject;
    },
    requiredNote() {
      return !_.trim(this.note) !== "";
    },
    codeAndMobile() {
      return `${_.get(this.contactData, "code", "")} - ${this.contactMobile}`;
    },
    arrayClassIds() {
      const result = [];
      if (this.studentClassList && this.studentClassList.length) {
        this.studentClassList.forEach((i) => {
          if (i.class_id) {
            result.push(i.class_id);
          }
        });
      }
      return result;
    },
    arrayClassActiveIds() {
      const array = [];
      if (this.studentClassList && this.studentClassList.length) {
        this.studentClassList.forEach((i) => {
          if (i.status_name === "Đang học" && i.class_id) {
            array.push(i.class_id);
          }
        });
      }
      return array;
    },
  },
  watch: {
    // Khi thay đổi môn học
    // chosenSubject: {
    //   handler(newVal) {
    //     console.log('chosenSubject');
    //     if (this.isCreatedLifeCycleDone) {
    //       this.getClassListOfSubject(this.programsOfContact[this.chosenSubject], newVal);
    //     }
    //     this.getTeacherOfContact();
    //   },
    //   immediate: false,
    // },

    tab: {
      handler(value, oldVal) {
        if (oldVal === POPUP_DETAIL_TAB_INDEX.TASK) {
          this.loadRightData();
        }
        switch (value) {
          case POPUP_DETAIL_TAB_INDEX.EXCHANGE:
            this.fetchContactNotes();
            break;
          case POPUP_DETAIL_TAB_INDEX.ORDER:
            this.fetchContactOrders();
            break;
          case POPUP_DETAIL_TAB_INDEX.LOGS:
            this.fetchContactLogs();
            break;
          case POPUP_DETAIL_TAB_INDEX.ACTIVITY:
            this.$refs.activityTab.getListActivity();
            break;
          case POPUP_DETAIL_TAB_INDEX.NOTE:
            this.$refs.noteTab.getListNotes();
            break;
          default:
            break;
        }
      },
    },

    arrayClassIds(paginate = {}) {
      if (this.arrayClassIds?.length > 0) {
        const params = {
          classIds: this.arrayClassIds,
          page: paginate.page ? paginate.page : 0,
          limit: paginate.limit ? paginate.limit : 20,
        };
        this.getListVideos(params);
      }
      if (this.arrayClassIds?.length < 1) {
        this.listVideos = [];
      }
    },

    arrayClassActiveIds() {
      const params = {
        student_id: this.studentClassList[0]?.student_id,
        subject_id: this.programsOfContact[this.chosenSubject].subject_id,
        curriculum_id: this.programsOfContact[this.chosenSubject].curriculum_id,
      };
      if (params.student_id && params.subject_id) {
        this.careAttendance(params);
      }
    },
  },
  methods: {
    ...mapActions("student_care", [
      "getContactDetail",
      "getContactOrder",
      "getContactLogs",
      "getContactNotes",
      "updateContactHistory",
      "createContactHistory",
      "deleteContactHistory",
      "getTransferOrderStudents",
      "getTransferOrderStudentsV2",
      "apiUpdate",
      "getDataPeriodicallyCareTable",
      "getListStudentClass",
      "getTeacher",
      "getHomeworkList",
      "getListReviewCare",
      "getListVideo",
      "getCareAttendance",
      "getListProgramOfStudentByLmsCoreUserId",
      "getLessonByStudent",
      "getStudentProduct",
      "getCareAttendanceIeltsy",
      "getListGVCNV2",
      "getListProgram",
    ]),
    closeArrange1NPopup() {
      this.isShowArrangeClassPopup = false;
    },
    setArrangeClassType(val) {
      this.arrangeClassType = val;
    },
    handleChangeHeadTeacher(val) {
      if(val && typeof val === 'object') {
        this.changeHeaderTeacher(val)
      }
    },
    handleRemoveHeadTeacher() {
      if (this.dataHomeroomTeacher.id) {
        this.changeHeaderTeacher({
          id: null,
          name: null
        })
      }
    },
    handleShowSortClassPopup() {
      if (this.arrangeClassType === 1) {
        this.modalDetailClass = true;
      } else {
        this.isShowArrangeClassPopup = true;
      }
    },
    closeModalDetailClass() {
      this.modalDetailClass = false;
      this.classId = null;
    },
    handleShowSpecialCareDetail() {
      this.tab = POPUP_DETAIL_TAB_INDEX.LOGS;
    },
    checkPermissionByRoute() {
      if (((this.checkAuthorization('tutor-care-change-class-manager_read')
          || this.checkAuthorization('tutor-care-change-class-manager-limitation_read'))
          && this.$route.query.tutorSchoolLevel === SCHOOL_LEVEL.PRIMARY)
          || (this.checkAuthorization('tutor-student-detail-secondary-change-homeroom-teacher_read')
          && this.$route.query.tutorSchoolLevel === SCHOOL_LEVEL.SECONDARY)) {
        return false;
      }
      return true;
    },
    async getTaskLogs() {
      const result = await TaskRepository.getLogs({
        lms_core_user_id: this.contact.lms_core_user_id,
      });
      if (result.message === 'Success') {
        return result.data;
      }
      return [];
    },
    async getStudentId(id) {
      try{
        const response = await TicketRespository.getStudentIdApi(id)
        if(response.success) {
          this.studentId = response.data
        }else {
          this.studentId = response.data
        }
      }catch (e) {
        console.log(e)
      }
    },
    createdTicket() {
      const routeData = this.$router.resolve({
        path: '/customer-support',
        query: {
          studentId: this.studentId ? this.studentId : '',
          studentName: this.contact.full_name ? this.contact.full_name : '',
          homeRoomTeacherName: this.contact.homeroom_teacher_name ? this.contact.homeroom_teacher_name : '',
          customerCode: this.contactData.code ? this.contactData.code : '',
          module: this.contact && this.contact.type_curriculum === TYPE_CURRICULUM_OBJ.ONLINE ? 'Tutor' : 'Station',
        },
      });
      window.open(routeData.href, '_blank');
    },
    handleCopy(item) {
      navigator.clipboard.writeText(item).then(
        () => {
          this.$swal({
            type: 'success',
            icon: 'success',
            showConfirmButton: false,
            toast: true,
            timer: 1000,
            title: 'Sao chép thành công!',
            position: 'top',
          });
        },
      );
    },
    async getStudentClassList(customerId, subjectId) {
      this.dataLevel = null;
      this.loadingClass = true;
      this.studentClassList = [];
      if (!customerId) {
        this.loadingClass = false;
        return null;
      }
      if (!subjectId) {
        const params = {
          lms_core_user_id: customerId,
        };
        const res = await BlendedCareServices.getSelfStudyCourse(params);
        if (res && res.data) {
        this.curriculumId = 0
        this.studentClassList = res.data;
        // this.studentClassList = this.studentClassList.filter((i) => (
        //   i.status_name === DANG_HOC || i.status_name === CHO_KG
        // ));

        if (this.studentClassList.length) {
          this.studentClassList = this.studentClassList.map((i) => ({
            ...i,
            class_schedule: null,
          }));
          this.dataLevel = null;
        }
        } else {
          this.$swal({
            title: "Lỗi!",
            text: "Không gọi được danh sách lớp học của học sinh",
            type: "error",
          });
        }
      } else {
        const params = {
          "filters[contact_id]": this.selectedContactId,
          "filters[lms_core_user_id]": customerId || "null",
          "filters[subject_id]": subjectId,
          "filters[curriculum_id]": this.programId,
          // 'filters[$in__class_status_id]': [1, 2],
          attrs: [
            "name",
            "number_lessons_passed",
            "status_name",
            "class_start_time",
            "class_schedule",
            "number_lessons",
            "status_color",
            "class_level",
            "contact_id",
            "student_product_id",
            "class_id",
            "teacher_type",
            "student_id",
            "teacher_full_name",
            "learn_again_time",
            "curriculum_id",
            "join_date",
          ],
        };
        const res = await this.getListStudentClass(params);
        if (res.success) {
          this.curriculumId = res.data.map((e) => e.curriculum_id)
          this.curriculumId = res.data.map((e) => e.curriculum_id)
          this.studentClassList = res.data;
          // this.studentClassList = this.studentClassList.filter((i) => (
          //   i.status_name === DANG_HOC || i.status_name === CHO_KG
          // ));

          if (this.studentClassList.length) {
            this.studentClassList = this.studentClassList.map((i) => ({
              ...i,
              class_schedule: JSON.parse(i.class_schedule),
            }));
            this.dataLevel = this.studentClassList[0].class_level;
          }
        } else {
          this.$swal({
            title: "Lỗi!",
            text: "Không gọi được danh sách lớp học của học sinh",
            type: "error",
          });
        }
      }
      this.loadingClass = false;
      return 0;
    },
    async fetchContactNotes() {
      this.contactNoteHistories = await this.getContactNotes(this.contactId);
    },
    goToClassScheduling(item) {
      window.open(
        `${process.env.VUE_APP_ERP}/tutor/sort/student?studentId=${item.student_id}&teacherTypeId=${item.teacher_type}&classId=${item.class_id}&productId=${item.student_product_id}&contactId=${item.contact_id}`,
        "_blank"
      );
    },
    async fetchContactDataCreated() {
      this.contactChilds = [];
      this.contactData = await this.getContactDetail(this.contactId);
      this.contactChildName = this.contact.full_name;
      if (
        this.contactData &&
        this.contactData.customers &&
        this.contactData.customers.length > 1
      ) {
        if (this.checkAuthorization("call-zalo_read")) {
          this.dataZalo = await ContactRepository.userInteractiveZalo(
            this.contactData.customers[0].mobile
          );
        }
        for (let i = 0; i < this.contactData.customers.length; i += 1) {
          if (!this.contactData.customers[i].isMainCustomer) {
            if (
              this.contactData.customers[i].vhUserId !==
              this.contact.lms_core_user_id
            ) {
              this.contactChilds.push(this.contactData.customers[i]);
            } else {
              this.contactBirthday = this.contactData.customers[i].birthday;
            }
          }
          if (
            this.contactData.customers[i].isMainCustomer &&
            !this.contactParentName
          ) {
            this.contactParentName = this.contactData.customers[i].fullName;
            this.contactMobile = this.contactData.customers[i].mobile;
            if (
              this.contactData.customers[i].ward &&
              this.contactData.customers[i].province &&
              this.contactData.customers[i].district
            ) {
              this.contactAddress = `${this.contactData.customers[i].ward.ten}, ${this.contactData.customers[i].district.ten}, ${this.contactData.customers[i].province.ten}`;
            }
          }
        }
      }
      else if (
        _.get(this.contactData, 'customers', []).length === 1 &&
        this.contactData.customers[0].isMainCustomer &&
        this.contactData.customers[0].position === 'child'
      ) {
        this.contactBirthday = this.contactData.customers[0].birthday;
        this.contactParentName = this.contactData.customers[0].fullName;
        this.contactMobile = this.contactData.customers[0].mobile;
        if (
          this.contactData.customers[0].ward &&
          this.contactData.customers[0].province &&
          this.contactData.customers[0].district
        ) {
          this.contactAddress = `${this.contactData.customers[0].ward.ten}, ${this.contactData.customers[0].district.ten}, ${this.contactData.customers[0].province.ten}`;
        }
      }
    },
    async fetchContactData() {
      this.contactChilds = [];
      this.contactData = await this.getContactDetail(this.contactId);
      if (this.checkAuthorization("call-zalo_read")) {
        this.dataZalo = await ContactRepository.userInteractiveZalo(
          this.contactData.customers[0].mobile
        );
      }
      if (this.selectedContactChild !== "") {
        let indexDel = null;
        let itemSearch = null;
        this.contactData.customers = this.contactData.customers.filter(
          (item) => !item.isMainCustomer
        );
        for (let i = 0; i < this.contactData.customers.length; i += 1) {
          if (
            this.contactData.customers[i].vhUserId === this.selectedContactChild
          ) {
            itemSearch = this.contactData.customers[i];
            indexDel = i;
            this.childSelected = this.contactData.customers[i].vhUserId;
            break;
          }
        }
        this.contactChildName = itemSearch.fullName;
        this.contactBirthday = itemSearch.birthday;
        this.contactData.customers.splice(indexDel, 1);
        this.contactChilds = this.contactData.customers;
      }
      if (
        this.selectedContactChild === "" &&
        this.contactData &&
        this.contactData.customers &&
        this.contactData.customers.length > 1
      ) {
        for (let i = 0; i < this.contactData.customers.length; i += 1) {
          if (
            this.contactData.customers[i] &&
            !this.contactData.customers[i].isMainCustomer
          ) {
            if (!this.contactChildName) {
              this.contactChildName = this.contactData.customers[i].fullName;
              this.contactBirthday = this.contactData.customers[i].birthday;
            } else {
              this.contactChilds.push(this.contactData.customers[i]);
            }
          }
          if (
            this.contactData.customers[i] &&
            this.contactData.customers[i].isMainCustomer &&
            !this.contactParentName
          ) {
            this.contactParentName = this.contactData.customers[i].fullName;
            this.contactMobile = this.contactData.customers[i].mobile;
            if (
              this.contactData.customers[i].ward &&
              this.contactData.customers[i].province &&
              this.contactData.customers[i].district
            ) {
              this.contactAddress = `${this.contactData.customers[i].ward.ten}, ${this.contactData.customers[i].district.ten}, ${this.contactData.customers[i].province.ten}`;
            }
          }
        }
      }
    },
    async fetchContactOrders() {
      const result = await this.getContactOrder(this.contactId);
      if (result && result.data && result.data.length > 0) {
        this.orderList = result.data;
        this.totalItem = result.totalItem;
      }
      const res = await this.getTransferOrderStudents(this.contactId);
      if (res && res.length > 0) {
        this.listTransferOrder = res;
      }
      const resTransferOrderV2 = await this.getTransferOrderStudentsV2(this.contactId);
      if (resTransferOrderV2 && resTransferOrderV2.length > 0) {
        this.listTransferOrderV2 = resTransferOrderV2.map((el) => ({
          ...el,
          isTransferOrder: true,
          version: 2,
        }));
      }
      const totalListOrder = this.orderList
        .concat(this.listTransferOrder).concat(this.listTransferOrderV2)
        .map((s) => {
          let hasFinishOrder = null;
          let depositLabel = null;
          if (s.isGroupOrder) {
            let depositOrder = s.listOrders.find(
              (item) => item.orderType == ORDER_DEPOSIT_TYPE
            );
            if (depositOrder) {
              s.code = depositOrder.code;
              s.depositOrderId = depositOrder.id;
            }
            hasFinishOrder =
              s.listOrders.findIndex((e) => e.orderType == ORDER_FINISH_TYPE) >
              -1
                ? true
                : false;
            depositLabel = this.getDepositLabel(s.listOrders);
          }
          if (s && s.isTransferOrder) {
            return {
              ...s,
              statusOrder: true,
              hasFinishOrder,
              depositLabel,
              createdAt: moment(s.createdAt).format("YYYY-MM-DD HH:mm:ss"),
            }
          }
          if (s && s.created_date) {
            return {
              ...s,
              createdAt: moment(s.created_date).format("YYYY-MM-DD HH:mm:ss"),
              statusOrder: true,
              version: 1,
              hasFinishOrder,
              depositLabel,
            };
          }
          return { ...s, statusOrder: false, hasFinishOrder, depositLabel };
          if (s && s.created_date) {
            return {
              ...s,
              createdAt: moment(s.created_date).format("YYYY-MM-DD HH:mm:ss"),
              statusOrder: true,
            };
          }
          return { ...s, statusOrder: false };
        });
      this.totalListOrder = _.orderBy(
        totalListOrder,
        ["createdAt"],
        ["ASC"]
      ).reverse();
    },
    getDepositLabel(listOrder) {
      if (
        listOrder.every((item) =>
          namesOrderContactStatusTc.includes(
            item.contactStatus.name.toUpperCase()
          )
        ) &&
        listOrder.some((item) => item.orderType == ORDER_FINISH_TYPE)
      ) {
        return "Đã hoàn thành phí";
      } else if (
        listOrder.some((item) =>
          namesOrderContactStatusTc.includes(
            item.contactStatus.name.toUpperCase()
          )
        )
      ) {
        return "Đã thanh toán 1 phần";
      } else {
        return "Chưa thanh toán";
      }
    },
    async fetchContactLogs() {
      const [careHistoriesDetail, logContact, logTask] = await Promise.all([
        this.getAllHistoryCare({
          ...this.contact,
          type_customer_care: undefined,
        }),
        this.getContactLogs(this.contactId),
        this.getTaskLogs(),
      ]);
      const careHistoriesDetailForLog = careHistoriesDetail.filter(
        (e) => e.created_by === 100004 || e.type_customer_care === null,
      );
      const logs = [...careHistoriesDetailForLog, ...logContact, ...logTask].map((e) => ({
          creator: {
            fullName: this.convertText(e?.creator?.fullName) || this.convertText(e?.created_name) || this.convertText(contactCreator[e?.createdBy])
          },
          description: e?.note || e?.description || e?.content,
          createdAt: e.created_at || e.createdAt,
        }));
        this.contactHistories = _.orderBy(logs, ['createdAt'], ['desc']);
    },
    convertText(text) {
      const array = ['Log hệ thống', 'Hệ thống BOT'];
      if (array.includes(text)) {
        return 'Hệ thống';
      }
      return text;
    },
    async getAllHistoryCare(params) {
      const body = {
        obj: 'call-histories-detail',
        attrs: [
          'id',
          'created_name',
          'note',
          'call_name',
          'call_status_name',
          'call_status_id',
          'call_id',
          'created_at',
          'created_by',
          'type_customer_care',
          'type_curriculum',
          'type_blended',
        ],
        'filters[$eq__curriculum_id]':  this.programId,
        'filters[$eq__subject_id]': this.subjectId,
        'filters[$eq__lms_core_user_id]': params.lms_core_user_id,
        'filters[$eq__type_customer_care]': params.type_customer_care,
        'sorts[created_at]': 'desc',
      };
      const data = { ...body, 'filters[$eq__type_curriculum]': params.type_curriculum ? params.type_curriculum : this.$route.query.typeCurriculum };
      const res = await BlendedCareServices.fgGetListCare(data);
      if (res?.success) {
        return res?.data;
      }
      return [];
    },
    clickContactDetail(contactId) {
      const routeData = `${
        process.env.VUE_APP_CRM
      }/contact/contact-list/contact-detail/${contactId || 0}`;
      window.open(routeData, "_blank");
    },
    createOrder(contactId) {
      const routeData = `${process.env.VUE_APP_CRM}/contact/contact-list/${contactId}/order-create`;
      window.open(routeData, "_blank");
    },
    clickViewHistoryContact() {
      const contactId = this.contactData.id;
      this.$router.push({
        name: "ContactHistory",
        params: {
          id: contactId || 0,
        },
      });
    },
    async getContactHistory() {
      // const contactId = this.contactData.id;
      const params = {
        limit: 300,
        page: 0,
      };
      if (this.tab === 0) {
        params.action = "NOTE";
      } else {
        params.ne_action = ["NOTE", "OPERATION"];
      }
      if (this.tab < 4 && this.tab !== 2) {
        this.loading = true;
      } else if (this.tab === 2) {
        this.getInterviewsDetail();
        this.getNote();
      }
    },
    async clickCreateHistoryContact() {
      if (_.trim(this.note) === "") {
        this.reloadCreateNote = true;
        return;
      }
      const dataUpdate = {
        contactId: this.contactId,
        description: _.trim(this.note),
      };
      const loading = this.$loading.show();
      const response = await this.createContactHistory(dataUpdate);
      loading.hide();
      if (response.error) {
        this.errorMessage = _.get(response, "message", "");
        this.$swal({
          type: "error",
          title: "Lỗi !",
          text: this.errorMessage,
        }).then(() => {});
        return;
      }
      this.note = "";
      this.reloadCreateNote = false;
      await this.fetchContactNotes();
    },
    async changeSelectStatus() {
      // return this.$swal({
      //   title: 'Bạn muốn thay đổi mối quan hệ ?',
      //   type: 'warning',
      //   showCancelButton: true,
      //   confirmButtonText: 'Đồng ý',
      //   closeOnConfirm: false,
      //   cancelButtonText: 'Huỷ Bỏ'
      // }).then(async result => {
      //   if (result.value) {
      this.isStatusChange = true;
      this.contactData.statusId = this.statusId;
      return this.callAPIChangeStatus();
      // }
      // this.statusId = this.contactData.statusId;
      // });
    },
    async callAPIChangeStatus() {
      // const dataUpdate = [
      //   {
      //     contactId: this.contactData.id,
      //     statusId: this.statusId,
      //   },
      // ];
      this.loading = this.$loading.show();
    },
    async changeSelectUser() {
      if (!this.userId) {
        return this.$swal({
          title: "Chọn người phụ trách là bắt buộc?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Đồng ý",
        });
      }
      return this.$swal({
        title: "Bạn muốn thay đổi người phụ trách ?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Đồng ý",
        closeOnConfirm: false,
        cancelButtonText: "Huỷ Bỏ",
      }).then(async (result) => {
        if (result.value) {
          this.isStatusChange = true;
          if (!this.contactData.user) {
            this.contactData.user = {};
          }
          this.contactData.user.id = this.userId;
          return this.callAPIChangeUser();
        }
        this.userId = _.get(this.contactData, "user.id", "");
        return null;
      });
    },
    async callAPIChangeUser() {
      // const dataUpdate = [
      //   {
      //     contactId: this.contactData.id,
      //     userId: this.userId,
      //   },
      // ];
      this.loading = this.$loading.show();
    },
    clickHistoryCall(mobile) {
      const routeData = `${process.env.VUE_APP_CRM}/call-center/list?keyword=${mobile}`;
      window.open(routeData, "_blank");
    },
    clickExecuteCall(dataContact, phone, value) {
      if (
        (value === "ZL_BGVVH" && !this.dataZalo.ZL_BGVVH) ||
        (value === "ZL_CVHT" && !this.dataZalo.ZL_CVHT)
      ) {
        this.$swal({
          text: "Học sinh / Phụ huynh đã không tương tác qua zalo với vuihoc hơn 30 ngày.",
        });
        return;
      }
      const user = TokenService.getUser();
      if (user.ext) {
        const data = {
          mobile: phone,
          showCreateAppointment: false,
          contactId: this.contactId,
          mainId: dataContact.mainId,
          mainMobile: this.contactMobile,
          contactCode: dataContact.code,
          homeroomTeacherId: this.contact.homeroom_teacher_id,
          studentProductId: this.contact.student_product_id,
          callStatusId: this.contact.call_status_id,
          callId: this.contact.call_id,
        };
        if (value && value === "ZL_BGVVH") {
          data.mobile = 99 + this.dataZalo.zuid_ZL_BGVVH;
        }
        if (value && value === "ZL_CVHT") {
          data.mobile = 99 + this.dataZalo.zuid_ZL_CVHT;
        }
        Bus.$emit("voice-call-show-popup", data, value);
      } else {
        this.$swal({
          title: "Lỗi!",
          text: "Chưa có máy lẻ. Vui lòng liên hệ Admin.",
        });
      }
    },
    closeModal() {
      this.$emit("closeModalQuickView");
      if (this.isStatusChange) {
        // this.searchContact();
      }
    },
    searchContact() {
      Bus.$emit("contact-list-filter", this.filterForm);
      Bus.$emit("contact-status-list");
    },
    checkShowNote() {
      // eslint-disable-next-line no-unused-expressions
      this.checkAuthorization("contact_update")
        ? (this.showNote = true)
        : (this.showNote = false);
    },
    async deleteContactNoteHistory(contactHistory) {
      this.$swal({
        title: "Xóa lịch sử",
        text: "Bạn có thực sự chắc chắn ?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Hủy bỏ",
      }).then(async (result) => {
        if (result.value) {
          const loader = this.$loading.show();
          const response = await this.deleteContactHistory(contactHistory.id);
          loader.hide();
          if (response.success) {
            this.$swal({
              title: "Xóa thành công !",
              confirmButtonText: "Đồng ý",
            }).then(async () => {
              await this.fetchContactNotes();
            });
          } else {
            this.$swal({
              type: "error",
              title: "Lỗi !",
              text: _.get(response, "message", ""),
            });
          }
        }
      });
    },
    async updateContactNoteHistory(contactHistory) {
      const res = await this.updateContactHistory(contactHistory);
      if (res) {
        await this.fetchContactNotes();
      } else {
        this.errorMessage = _.get(res, "message", "");
        this.$swal({
          type: "error",
          title: "Lỗi !",
          text: this.errorMessage,
        }).then(() => {});
        await this.fetchContactNotes();
      }
    },
    async returnToBackStatus() {
      const loading = this.$loading.show();
      loading.hide();
      this.contactData.beforeSupport = null;
      this.getContactHistory();
    },
    async checkSupportContact() {
      const statusId = _.get(this.contactData, "statusId", 0);
      const beforeSupport = _.get(this.contactData, "beforeSupport", 0);
      const contactId = _.get(this.contactData, "id", 0);
      if (
        ((statusId >= 4 && statusId <= 13) || statusId === 49) &&
        // eslint-disable-next-line radix
        parseInt(beforeSupport) &&
        contactId
      );
      // this.isSupport = false
    },
    async getDetailContact(month = null, year = null) {
      const params = {
        contactId: this.contactData.id,
        limit: 10,
        page: this.currentPage - 1,
      };
      if (month && year) {
        params.month = month;
        params.year = year;
      } else {
        params.month = this.dataTime.month;
        params.year = this.dataTime.year;
      }
      // if (month != null && year != null) {
      //   params.month = month
      //   params.year = year
      // }
      const loader = this.$loading.show();
      // eslint-disable-next-line no-undef

      loader.hide();
      // return (this.dataInteraction = result);
      return null;
    },
    // viewInteractions() {
    //   this.isActiveCountInteractions = true;
    // },
    closePopupInteractions(variable) {
      this.dataTime = {};
      this.getDetailContact();
      this.isActiveCountInteractions = variable;
    },
    async selectContactStatusList() {
      const selectType = _.get(
        this.contactData,
        "contactStatus.type",
        "T"
      ).includes("T")
        ? ["T1", "T2", "T3"]
        : ["C1", "C2", "C3"];
      if (this.isStaff() && !this.checkAuthorization("contact_view_all")) {
        selectType.shift();
      }

      const contactStatusList = [];
      // const loading = this.$loading.show();
      this.contactStatusList = contactStatusList;
    },
    async getInterviewsDetail() {
      console.log("getInterviewsDetail");
    },
    async getNote() {
      console.log("getNote");
    },
    viewActiveCodes() {
      this.isActiveCodes = true;
    },
    async getActionLogTypeList() {
      if (this.$store.state.listActionLogType) {
        this.actionLogTypeList = this.$store.state.listActionLogType;
        // return;
      }
      // } else {
      //   // eslint-disable-next-line no-undef
      //   if (this.actionLogTypeList && this.actionLogTypeList.length) {
      //     this.$store.dispatch(
      //       'SET_LIST_ACTION_LOG_TYPE',
      //       this.actionLogTypeList,
      //     );
      //   }
      // }

      this.actionLogTypeList.forEach((item) => {
        if (!this.mapNamePointActionLog[item.name]) {
          this.mapNamePointActionLog[item.name] = item.point;
        }
      });
    },
    changeSubject(programOfContact, key) {
      this.chosenSubject = key;
      // this.objChosenSubject = _.cloneDeep(subject);
      this.dataHomeroomTeacher = null;
      // this.getClassListOfSubject(subject, key);

      this.getClassListOfSubject(
        this.programsOfContact[this.chosenSubject],
        key
      );
      this.getTeacherOfContact();
      Bus.$emit('reload-student-detail-info', this.programsOfContact[this.chosenSubject].id);
      this.loadRightData();
    },
    getClassListOfSubject(programOfContact, key) {
      this.selectedProgram = programOfContact;
      this.subjectId = programOfContact.subject_id;
      this.programId = programOfContact.curriculum_id;
      this.chosenSubject = key;
      this.chosenSubjectName = this.getSubjectById(programOfContact.subject_id).name;
      this.selectedSubjectId = programOfContact.subject_id;
      // this.$emit('getClassListOfSubjectId', { subjectId: this.subjectId, child: this.selectedContactChild });
      // if (!isCreated) {
      //   this.getHomeworkStudent();
      // }
      this.getStudentClassList(this.selectedContactChild, this.subjectId);
    },
    async changeContactChild() {
      await this.fetchContactData();
      // const params = {
      //   childId: this.selectedContactChild,
      //   subjectId: this.subjectId,
      // };
      // this.$emit('getClassListOfChild', params);
      // this.getHomeworkStudent();
      this.getStudentClassList(this.selectedContactChild, this.subjectId);
      this.getTeacherOfContact();
      this.loadRightData();
      this.getPriorityTeacher();
    },
    async getHomeworkStudent() {
      if (!this.selectedContactChild || !this.selectedSubjectId) {
        return;
      }
      const params = {
        lms_core_user_id: this.selectedContactChild,
        subject_id: this.selectedSubjectId,
        curriculum_id: this.programId,
      };
      await this.getHomeworkList(params);
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY HH:mm");
    },
    async changeHeaderTeacher(val) {
      let selectTeacherId = null;
      let selectTeacherName = null;

      if (val && val.id) {
        selectTeacherId = val.id;
        selectTeacherName = val.name;
      }
      const body = {
        obj: "routine",
        data: {
          homeroom_teacher_id: selectTeacherId,
          homeroom_teacher_name: selectTeacherName,
        },
        filters: {
          $in__id: [this.id],
        },
        oldData: [
          {
            id: this.id,
            homeroom_teacher_name: this.flagOldDataTeacher.name,
          },
        ],
      };

      const resUpdate = await this.apiUpdate(body);
      if (resUpdate && resUpdate.message === 'Success') {
        this.$swal({
          type: "success",
          icon: "success",
          text: "Chuyển quản lý lớp thành công!",
        })
        // await this.getDataPeriodicallyCareTable(this.filterForm);
        this.flagOldDataTeacher = {
          id: selectTeacherId,
          name: selectTeacherName,
        };
      } else {
        this.$swal({
          type: "error",
          icon: "error",
          title: "Có lỗi khi thực hiện chuyển quản lý lớp",
          text: resUpdate.message,
        })
      }
      this.loadRightData();
    },
    async getLessonByStudentAndProgram() {
      this.lessonByStudent = await this.getLessonByStudent({
        subject_id: this.subjectId,
        lms_core_user_id: this.selectedContactChild,
        curriculum_id: this.programId,
      });
    },
    showPopupOnLeave(student) {
      this.isPopupOnLeave = true;
      this.detailStudent = student;
    },
    closeDialogOnLeave() {
      this.isPopupOnLeave = false;
    },
    showPopupReserve(student) {
      this.isPopupReserve = true;
      this.detailStudent = student;
    },
    showPopupLearnAgain(student) {
      this.isPopupLearnAgain = true;
      this.detailStudent = student;
    },
    showPopupTransferFee(student) {
      this.isPopupTransferFee = true;
      this.detailStudent = student;
    },
    closeDialogLearnAgain() {
      this.isPopupLearnAgain = false;
    },
    closeDialogReserve() {
      this.isPopupReserve = false;
    },
    async getTeacherOfContact() {
      this.dataHomeroomTeacher = null;
      const params = {
        "filters[lms_core_user_id]": this.selectedContactChild,
        "filters[subject_id]": this.selectedSubjectId,
        attrs: ["homeroom_teacher_id", "homeroom_teacher_name"],
      };
      await this.getTeacher(params)
        .then((res) => {
          if (res.data && res.data.length) {
            this.dataHomeroomTeacher = {
              name: res.data[0].homeroom_teacher_name,
              id: res.data[0].homeroom_teacher_id,
            };
          }
        })
        .catch();
    },
    loadRightData() {
      setTimeout(() => {
        Bus.$emit("load-right-data", {
          subjectId: this.subjectId,
          programId: this.programId,
        });
      }, 200);
      this.getLessonByStudentAndProgram();
    },
    careAttendance: _.debounce(async function (params) {
      if (this.$store.state.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY) {
        this.attendedStudent = await this.getCareAttendanceIeltsy(params);
      } else {
        this.attendedStudent = await this.getCareAttendance(params);
      }
    }, 500),
    getListVideos: _.debounce(async function (params) {
      if (!params.arrayClassIds?.length) {
        params.classIds = this.arrayClassIds;
      }
      let res = await this.getListVideo(params);
      this.listVideos = res.data;
      this.totalListVideo = res.totalItem ? res.totalItem : 0;
    }, 500),
    // checkConditionShowTicket
    checkConditionShowTicket(item) {
      if (
        item.status_name === "Bảo lưu" ||
        item.status_name === "Hết buổi" ||
        item.status_name === "Đã kết thúc" ||
        item.status_name === "Chờ xếp lớp"
      ) {
        return false;
      }
      return true;
    },
    checkConditionShowTicket2(item) {
      if (
        item.status_name === "Đang học" ||
        item.status_name === "Chờ khai giảng" ||
        item.status_name === "Chờ chuyển lớp" ||
        item.status_name === "Chờ xếp lớp" ||
        item.status_name === "Chuyển phí"
      ) {
        return true;
      }
      return false;
    },
    isReserve(item) {
      if (item.status_name === "Bảo lưu") {
        return true;
      }
      return false;
    },
    async getPriorityTeacher() {
      const res = await ContactRepository.getPriorityTeacher(
        this.selectedContactChild
      );
      if (!res.success) {
        this.$swal({
          type: "error",
          title: "Lỗi !",
          text:
            res.message ??
            "Có lỗi xảy ra khi lấy trạng thái tích chọn điểm danh!",
          timer: 3000,
        });
        return;
      }
      if (res && res.data) {
        if (
          res.data.priority_status === CHECK_ATTENDANCE_PRIORITY.NO_PRIORITY
        ) {
          this.priority = false;
          this.no_call = false;
          this.priority_status = res.data.priority_status;
        }
        if (res.data.priority_status === CHECK_ATTENDANCE_PRIORITY.PRIORITY) {
          this.priority = true;
          this.no_call = false;
          this.priority_status = res.data.priority_status;
        }
        if (res.data.priority_status === CHECK_ATTENDANCE_PRIORITY.NO_CALL) {
          this.priority = false;
          this.no_call = true;
          this.priority_status = res.data.priority_status;
        }
      }
    },
    checkPriority() {
      if (this.priority) {
        this.no_call = false;
      }
      this.actionChangePriority();
    },
    checkNoCall() {
      if (this.no_call) {
        this.priority = false;
      }
      this.actionChangePriority();
    },
    /* eslint-disable */
    actionChangePriority: _.debounce(async function () {
      const body = {
        lmsCoreUserId: this.selectedContactChild,
        priorityStatus: 0,
      };
      if (!this.priority && !this.no_call) {
        body.priorityStatus = CHECK_ATTENDANCE_PRIORITY.NO_PRIORITY;
      } else if (this.priority) {
        body.priorityStatus = CHECK_ATTENDANCE_PRIORITY.PRIORITY;
      } else {
        body.priorityStatus = CHECK_ATTENDANCE_PRIORITY.NO_CALL;
      }
      const res = await ContactRepository.changePriorityTeacher(body);
      if (!res.success) {
        this.$swal({
          type: "error",
          title: "Lỗi !",
          text: res.message ?? "Có lỗi xảy ra khi tích chọn điểm danh!",
          timer: 3000,
        });
        return;
      }
      this.$swal({
        type: "success",
        title: "Đã tích chọn điểm danh!",
        timer: 3000,
      });
      this.logAttendance();
    }, 1000),
    async logAttendance() {
      const body = {
        id: this.id,
        oldPriorityStatus: this.priority_status,
        priorityStatus: 0,
      };
      if (!this.priority && !this.no_call) {
        body.priorityStatus = CHECK_ATTENDANCE_PRIORITY.NO_PRIORITY;
      } else if (this.priority) {
        body.priorityStatus = CHECK_ATTENDANCE_PRIORITY.PRIORITY;
      } else {
        body.priorityStatus = CHECK_ATTENDANCE_PRIORITY.NO_CALL;
      }
      const res = await ContactRepository.logAttendance(body);
      await this.getPriorityTeacher();
    },
    /* eslint-disable */
    closePopupLearnAgain() {
      this.isPopupLearnAgain = false;
    },
    createLearnAgainSuccessfully() {
      // const params = {
      //   childId: this.selectedContactChild,
      //   subjectId: this.subjectId,
      // };
      // this.$emit('createLearnAgainSuccessfully', params);
      this.getStudentClassList(this.selectedContactChild, this.subjectId);
    },
    async getStudentProductByLmsId() {
      let school = await this.getStudentProduct(this.contact.lms_core_user_id);
      school = school.filter((item) => item.school);
      if (school?.length) this.school = school[0]?.school;
    },
     actionUser(key) {
      if (key === 'call') {
        this.clickExecuteCall(this.contactData, this.contactMobile);
        return;
      }
      if (key === 'order') {
        this.createOrder(this.contactData.id);
      }
      if (key === 'ticket') {
        this.createdTicket();
      }
      if (key === 'todos') {
        Bus.$emit('openModalTriggerTask', null, this.contact);
      }
    },
    checkExpiredate(val) {
      return moment(val).isBefore(moment());
    }
  },
};
</script>
<style lang="scss" scoped>
.join-date-tooltip {
  border: 1px solid;
  border-color: #ccc !important;
  opacity: 1;
  color: black;
  padding: 6px;
}
::v-deep .v-subheader.theme--light {
  font-size: 10px;
  font-weight: bold;
}
::v-deep .v-input--selection-controls {
  margin: 0;
}
.checkbox-priority {
  max-width: 60% !important;
}
.contact-history-table--wrapper {
  max-height: 587px;
  overflow: hidden;
}
::v-deep .v-tabs-bar {
  height: 30px;
}
::v-deep .v-tab {
  font-size: 12px;
}
.appointment-time-wrapper {
  padding: 5px;
  border: 1px solid #a9a9a9;
  border-radius: 5px;
  font-weight: 700;
}
.class-list {
  background: #f7f7fc;
  overflow: auto;
  max-height: 300px;
}
.class-item {
  border: 1px solid #d2d2d2;
  border-radius: 5px;
  background: #fff;
  padding: 5px 14px;
}
.schedule-day {
  font-weight: 600;
  /* background-color: rgb(233, 237, 245);
  border-color: rgb(233, 237, 245);
  padding: 4px 6px;
  border-radius: 6px !important; */
}
.customer-learning {
  background: #e0e0e0;
  color: #828282;
  font-size: 13px;
  font-weight: 800;
  border-radius: 2px;
  margin-right: 10px;
  height: 30px !important;
}
.active {
  background: #6a2c62 !important;
  color: #fff !important;
}
.contact-address {
  font-weight: 300;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  span {
    font-weight: 500;
  }
}
.title-student-class {
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  line-height: 20px;
}
.fill-text-field {
  padding: 0;
  margin: 0;
  font-weight: 500;
  font-size: 13px;
}
.quick-view {
  position: relative;
  background: #fff;
  ::v-deep .v-card__title {
    position: sticky;
    top: 0;
    left: 0;
    background: white;
    z-index: 10000;
  }
}

.text-center.quick-view.v-card.v-sheet.theme--light {
  max-height: calc(100vh - 60px) !important;
  overflow-y: auto !important;
}
.d-webkit-box {
  display: -webkit-box !important;
}
button.customer-learning.v-btn.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default {
  padding: 0 20px !important;
}
.select-child {
  width: 15%;
  color: #2f80ed;
  font-size: 12px;
  -webkit-appearance: auto;
  margin-left: -5px;
  font-weight: 500;
  border-bottom: 1px solid #2f80ed;
}
.select-child {
  position: absolute;
}
.counter-child {
  color: #2f80ed;
  position: relative;
  left: 0;
  top: -7px;
}
.class-studying {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  background: #fff;
  // border: 1px solid #D2D2D2;
  // border-radius: 5px;
  // padding: 16px 15px 20px 19.5px;
  font-weight: 400;
  .item-studying {
    font-weight: 700;
  }
  .lesson {
    color: #2b2b2b;
  }
  .vertical {
    color: #bdbdbd;
  }
}
.w-1-2 {
  width: 40%;
}
.student-detail-card {
  background: white;
  border-radius: 12px;
  width: 100%;
  padding: 16px;
  margin-top: 15px;
}
.student-avatar {
  border-radius: 50%;
  width: 100%;
}
.student-name {
  font-size: 18px;
  font-weight: bold;
  color: black;
}
.student-code {
  color: #848484;
  font-size: 12px;
}
  @media screen and (max-width: 1440px) {
    .student-detail-card {
      font-size: 12px;
      #avt {
        display: flex;
        .student-avatar {
          margin: auto;
        }
      }
      #advanded {
        display: block !important;
        .v-label {
          font-size: 12px !important;
        }
      }
      .student-name {
        font-size: 16px;
      }
    }
  }
  /* HTML:<div class="loader"></div> */
.loader {
  width: 20px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 4px solid #514b82;
  animation:
    l20-1 0.8s infinite linear alternate,
    l20-2 1.6s infinite linear;
}
@keyframes l20-1{
   0%    {clip-path: polygon(50% 50%,0       0,  50%   0%,  50%    0%, 50%    0%, 50%    0%, 50%    0% )}
   12.5% {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100%   0%, 100%   0%, 100%   0% )}
   25%   {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100% 100%, 100% 100%, 100% 100% )}
   50%   {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100% 100%, 50%  100%, 0%   100% )}
   62.5% {clip-path: polygon(50% 50%,100%    0, 100%   0%,  100%   0%, 100% 100%, 50%  100%, 0%   100% )}
   75%   {clip-path: polygon(50% 50%,100% 100%, 100% 100%,  100% 100%, 100% 100%, 50%  100%, 0%   100% )}
   100%  {clip-path: polygon(50% 50%,50%  100%,  50% 100%,   50% 100%,  50% 100%, 50%  100%, 0%   100% )}
}
@keyframes l20-2{
  0%    {transform:scaleY(1)  rotate(0deg)}
  49.99%{transform:scaleY(1)  rotate(135deg)}
  50%   {transform:scaleY(-1) rotate(0deg)}
  100%  {transform:scaleY(-1) rotate(-135deg)}
}
</style>
